import React, { useMemo } from "react";
import styles from '../styles/eventList.module.scss'
import { useInvitePrizeConfig } from "../hooks/useInviteFriends";
import { useTranslation } from "react-i18next";

const EventList = ({prizeConfigData}) => {
  const { t } = useTranslation('inviteFriends')
  const titleList = [t('eventList.inviteCount'), t('eventList.inviteCommission'), t('eventList.totalCommission')]

  const data:any =useMemo(()=>{
    return prizeConfigData && prizeConfigData.peopleAwardList
  },[prizeConfigData])

  const getInviteNumber = (item, i) => {
    let strInviteNumber =''
    if(i===0){
      strInviteNumber += item.inviteNumber
    }else if(i<((data?.length)-1)){
      strInviteNumber += item.inviteNumber + '~' + ((data[i+1]?.inviteNumber)-1)
    }else{
      strInviteNumber += item.inviteNumber + t('eventList.above')
    }
    return strInviteNumber
  }

  return <div className={styles.eventList}>
    <div className={styles.title}>
      {titleList.map((v,index)=>{
        return <div key={index}>{v}</div>
      })}
    </div>
      
    <div>
      {data?.map((v,index)=>{
          return <div key={index} className={styles.item}>
            <div>{getInviteNumber(v,index)}</div>
            <div>{v.inviterBonus}</div>
            <div>{(index<data?.length-1) ? v.bonusLimit : v.bonusLimit + t('eventList.andAbove')}</div>
          </div>
        })}
    </div>
  </div>
}

export default EventList